import React from "react";
import {
  carRideIcon,
  curbToCurbIcon,
  doorToDoorIcon,
  personToPersonIcon,
  wavIcon,
} from "../../../assets/images";
import styles from "../../Shared/VehicleCard/VehicleCard.module.scss";
import GoogleLoader from "../../../assets/Loader/GoogleSvgLoader/GoogleLoader";

const getTransportationIcons = (title: string): JSX.Element => {
  switch (title) {
    case "Standard":
      return (
        <img src={carRideIcon} alt="cab" className={styles.modeCardIcon} />
      );
    case "WAV":
      return <img src={wavIcon} alt="wav" className={styles.modeCardIcon} />;
    case "Curb-to-Curb":
      return (
        <img
          src={curbToCurbIcon}
          alt="curb to curb"
          className={styles.levelCardIcon}
        />
      );
    case "Door-to-Door":
      return (
        <img
          src={doorToDoorIcon}
          alt="door to door"
          className={styles.levelCardIcon}
        />
      );
    case "Person-to-Person":
      return (
        <img
          src={personToPersonIcon}
          alt="person to person"
          className={styles.levelCardIcon}
        />
      );
    default:
      return <GoogleLoader />;
  }
};

export default getTransportationIcons;
